import * as React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ConsoleHelper from 'src/shared/functions/consoleHelper';

export type SelectionAutocompleteProps<T> = {
  items: T[];
  callback: (item: T | null) => void;
  label: string;
  nameProp: string;
  valueProp: string;
};

const SelectionAutocomplete = <T,>(props: SelectionAutocompleteProps<T>) => {
  const { items, callback, label, nameProp, valueProp } = props;
  const { t } = useTranslation(['groupMessage']);
  const [, setValue] = React.useState<T | null>(null);

  if (items && items[0]) {
    if (!Object.prototype.hasOwnProperty.call(items[0], nameProp)) ConsoleHelper.error(`Missing nameProp ${nameProp} on type`);
    if (!Object.prototype.hasOwnProperty.call(items[0], valueProp)) ConsoleHelper.error(`Missing valueProp ${valueProp} on type`);
  }

  return (
    <Autocomplete
      options={items}
      getOptionLabel={(option: T) => option[nameProp]}
      isOptionEqualToValue={(option, val) => option[valueProp] === val[valueProp]}
      renderOption={(p, option) => (
        <li {...p} key={option[valueProp]}>
          {option[nameProp]}
        </li>
      )}
      onChange={(event, newValue: T | null) => {
        callback(newValue);
        setValue(newValue);
      }}
      sx={{ width: 300 }}
      renderInput={(params) => <TextField {...params} size='small' variant='outlined' label={t(label)} />}
    />
  );
};

export default SelectionAutocomplete;
